import React from 'react';
export const LoadingScreen = () => {
  return <div className="fixed inset-0 flex flex-col items-center justify-center z-50" data-id="element-162">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/7YdNxZ9mFYYJyok82S2yka/pasted-image.jpg')"
    }} data-id="element-163" />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-black/60" data-id="element-164" />
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center" data-id="element-165">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6bvXLLLbgQPyGsuTNy77Kh/Screenshot_2025-04-12_at_11.48.16_AM-removebg-preview.png" alt="Chicago Kush Logo" className="h-32 animate-pulse" data-id="element-166" />
        <div className="mt-8" data-id="element-167">
          <div className="w-48 h-1 bg-gray-800/50 backdrop-blur-sm rounded-full overflow-hidden" data-id="element-168">
            <div className="w-full h-full bg-red-600 animate-loading-bar" data-id="element-169" />
          </div>
        </div>
      </div>
    </div>;
};